module.exports = __webpack_public_path__ + "static/main-ss.438f8a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/main-ss.png
// module id = 1184
// module chunks = 277036769636407